import { deleteConverstaion, editConverstaion, createConverstaion } from "../../api/conversation/modal.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";


import { logout } from "../../../../shared/state/slices/user.js";
const ConversatoinModal = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
  allFeilds,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const {id} = useParams()

  const [selectedProductImage, setselectedProductImage] = useState();
  const { userPermissions } = useSelector((state) => state.relationals);
  const [catSearchWord, setCatSearchWord] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({ isDefault: false });
  const [openDelete, setOpenDelete] = useState(false);
  const [showingCats, setShowingCats] = useState([]);
  useEffect(() => {
    setShowingCats(allFeilds);
  }, [allFeilds]);
  useEffect(() => {
    const notFilteredRows = [...showingCats];
    let afterFilterRows = notFilteredRows.filter((row) =>
      row.title.toLowerCase().includes(catSearchWord.toLowerCase())
    );
    setShowingCats(afterFilterRows);
  }, [catSearchWord]);
  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
     
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit, allFeilds]);
  const resetData = () => {
    setPrevData(data);
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteConverstaion(data, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };
  const editItem = () => {
    var temp = [...allRows];


      setLoading(true);
      if (forEdit) {
        editConverstaion(prevData, token)
          .then((res) => {
            setLoading(false);
            toast.success("با موفقیت ویرایش شد");
            var index = temp.findIndex((item) => item.id === data.id);
            temp[index] = res.data.data;
            setAllRows(temp);
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      } else {
        createConverstaion(prevData, token)
          .then((res) => {
            temp.unshift(res.data.data);

            setAllRows(temp);
            setLoading(false);
            toast.success("با موفقیت اضافه شد");
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      }
   
  };

  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}  دسته بندی ها
    `}
    >

      <TextField
        label="متن پیام   "
        onChange={(e) => setPrevData({ ...prevData, message: e.target.value })}
        value={prevData?.message ?? ""}
        focused
        fullWidth
        multiline
        rows={3}
      />
 
  
      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این  پیام اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default ConversatoinModal;
